import { useMutation } from '@tanstack/react-query';
import { fetchIndustrySuggestions } from 'api/industries/industries.requests.ts';

export const useFetchIndustrySuggestions = () =>
  useMutation({
    mutationKey: ['industrySearch'],
    mutationFn: fetchIndustrySuggestions,
  });
